export default __webpack_public_path__ + "static/media/vodacom.b0882486.svg";